module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question",
    class: {
      selected: _vm.isSelected, odd: _vm.isOdd, static: _vm.isStatic, editable: _vm.isEditable
    }
  }, [_c('div', {
    staticClass: "header",
    on: {
      "click": _vm.handleSelect
    }
  }, [_c('div', {
    staticClass: "question-title"
  }, [(!_vm.isStatic) ? _c('span', {
    staticClass: "order-indicator"
  }, [_vm._v("\n        " + _vm._s(_vm.index + 1) + ".\n        "), (_vm.value.visibilityCondition) ? _c('span', {
    staticClass: "conditional"
  }, [_vm._v("?")]) : _vm._e()]) : _c('span', {
    staticClass: "order-indicator"
  }, [_vm._v("1.")]), _vm._v("\n      " + _vm._s(_vm.value.title) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "tools"
  }, [_c('div', {
    staticClass: "question-type"
  }, [_vm._v(_vm._s(_vm.friendlyQuestionType))]), _vm._v(" "), (!_vm.isStatic) ? _c('div', {
    staticClass: "controls"
  }, [(_vm.isEditable) ? _c('span', [_c('span', {
    staticClass: "option"
  }, [_c('el-tooltip', {
    attrs: {
      "content": "Conditional"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-link",
    class: {
      'has-conditional': _vm.isConditional(_vm.value)
    },
    on: {
      "click": function($event) {
        return _vm.handleSetConditional(_vm.value)
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    staticClass: "tool-divider"
  }), _vm._v(" "), _c('span', {
    staticClass: "option"
  }, [_c('el-tooltip', {
    attrs: {
      "content": "Edit"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-pencil",
    on: {
      "click": _vm.handleEdit
    }
  })])], 1), _vm._v(" "), _c('span', {
    staticClass: "option"
  }, [_c('el-tooltip', {
    attrs: {
      "content": "Remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-trash",
    on: {
      "click": _vm.handleRemove
    }
  })])], 1), _vm._v(" "), (_vm.isEditableQuestion) ? _c('el-divider', {
    attrs: {
      "direction": "vertical"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isEditableQuestion) ? _c('span', {
    staticClass: "collapse-toggler option"
  }, [_c('i', {
    staticClass: "fa fa-fw",
    class: _vm.isCollapsed ? 'fa-angle-down' : 'fa-angle-up',
    on: {
      "click": _vm.handleToggleCollapse
    }
  })]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.isEditableQuestion) ? _c('div', {
    staticClass: "body"
  }, _vm._l((_vm.editors), function(editor, index) {
    return _c('div', {
      key: index
    }, [(editor.condition(_vm.value)) ? _c(editor.component, {
      tag: "component",
      attrs: {
        "isCollapsed": _vm.isCollapsed,
        "isEditable": _vm.isEditable
      },
      on: {
        "onToggleCollapse": _vm.handleToggleCollapse
      },
      model: {
        value: (_vm.computedValue),
        callback: function($$v) {
          _vm.computedValue = $$v
        },
        expression: "computedValue"
      }
    }) : _vm._e()], 1)
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-486ad08c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveybuilder/editors/QuestionEditor.vue
// module id = 3264
// module chunks = 3